var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { TextAlignHelper } from '../../shared/helpers/text-align-helper';
import { FontStyleHelper } from '../../shared/helpers/font-style-helper';
import { FontFamilyHelper } from '../helpers/font-family-help';
import { ConfigureComponentBase } from '../../../../shared/configure-component-base';
import { FontSizeHelper } from '../helpers/font-size-helper';
var FontStyleComponent = /** @class */ (function (_super) {
    __extends(FontStyleComponent, _super);
    function FontStyleComponent(injector) {
        var _this = _super.call(this, injector) || this;
        _this.fontSizeChange = new EventEmitter();
        _this.textAlignChange = new EventEmitter();
        _this.isUnderlineChange = new EventEmitter();
        _this.fontColorChange = new EventEmitter();
        _this.fontStyleChange = new EventEmitter();
        _this.fontFamilies = FontFamilyHelper.getFontFamilies();
        _this.fontSizes = FontSizeHelper.getFontSizes();
        return _this;
    }
    Object.defineProperty(FontStyleComponent.prototype, "fontSize", {
        get: function () {
            return FontStyleHelper.dropPx(this.fontSizeValue);
        },
        set: function (value) {
            this.fontSizeValue = FontStyleHelper.addPx(value);
            this.fontSizeChange.emit(this.fontSizeValue);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FontStyleComponent.prototype, "textAlignEnabled", {
        get: function () {
            return null != this.textAlignValue;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FontStyleComponent.prototype, "textAlign", {
        get: function () {
            return this.textAlignValue;
        },
        set: function (value) {
            this.textAlignValue = value;
            this.textAlignChange.emit(value);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FontStyleComponent.prototype, "fontColor", {
        get: function () {
            return this.fontColorValue;
        },
        set: function (value) {
            this.fontColorValue = value;
            this.fontColorChange.emit(value);
            $('.evo-pointer').css('background', 'none');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FontStyleComponent.prototype, "alignLeft", {
        get: function () {
            return TextAlignHelper.isAlignLeft(this.textAlign);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FontStyleComponent.prototype, "alignCenter", {
        get: function () {
            return TextAlignHelper.isAlignCenter(this.textAlign);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FontStyleComponent.prototype, "alignRight", {
        get: function () {
            return TextAlignHelper.isAlignRight(this.textAlign);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FontStyleComponent.prototype, "fontStyle", {
        get: function () {
            return this.fontStyleValue;
        },
        set: function (value) {
            this.fontStyleValue = value;
            this.ininFontStyle();
        },
        enumerable: true,
        configurable: true
    });
    FontStyleComponent.prototype.ngOnInit = function () {
        $('.evo-pointer').css('background', 'none');
    };
    FontStyleComponent.prototype.setBold = function () {
        this.isBold = !this.isBold;
        this.changeFontStyle();
    };
    FontStyleComponent.prototype.setItalic = function () {
        this.isItalic = !this.isItalic;
        this.changeFontStyle();
    };
    FontStyleComponent.prototype.setUnderline = function () {
        this.isUnderline = !this.isUnderline;
        this.isUnderlineChange.emit(this.isUnderline);
    };
    FontStyleComponent.prototype.setAlignLeft = function () {
        this.textAlign = TextAlignHelper.AlignLeft;
    };
    FontStyleComponent.prototype.setAlignCenter = function () {
        this.textAlign = TextAlignHelper.AlignCenter;
    };
    FontStyleComponent.prototype.setAlignRight = function () {
        this.textAlign = TextAlignHelper.AlignRight;
    };
    FontStyleComponent.prototype.ininFontStyle = function () {
        this.isBold = FontStyleHelper.isBold(this.fontStyleValue);
        this.isItalic = FontStyleHelper.isItalic(this.fontStyleValue);
        this.fontFamily = FontStyleHelper.fontFamily(this.fontStyleValue);
    };
    FontStyleComponent.prototype.changeFontStyle = function () {
        this.fontStyleValue = FontStyleHelper.buildFontStyle(this.isBold, this.isItalic, FontStyleHelper.addPx(this.fontSize), this.fontFamily);
        this.fontStyleChange.emit(this.fontStyleValue);
    };
    FontStyleComponent.prototype.onFontSizeChanged = function (args) {
        var fontSizeValue = FontStyleHelper.dropPx(args.value);
        if (fontSizeValue > 1000) {
            this.fontSize = 1000;
        }
        else if (fontSizeValue <= 0 || isNaN(fontSizeValue)) {
            this.fontSize = null;
        }
        FontStyleHelper.updateDropdownDisplayValue(this.fontSize, this.fontSizeDropdown);
        if (this.fontSize != null) {
            this.changeFontStyle();
        }
    };
    FontStyleComponent.prototype.onFontFamilyChanged = function () {
        this.changeFontStyle();
    };
    FontStyleComponent.prototype.onFontSizeKeyDown = function (event) {
        FontStyleHelper.limitInputIsNumber(event);
    };
    FontStyleComponent.prototype.validateFontSize = function (currentFormControl) {
        return FontStyleHelper.fontSizeValidate(currentFormControl.value);
    };
    FontStyleComponent.prototype.setFontColor = function (color) {
        this.fontColor = color;
    };
    __decorate([
        Output()
    ], FontStyleComponent.prototype, "fontSizeChange", void 0);
    __decorate([
        Input()
    ], FontStyleComponent.prototype, "fontSize", null);
    __decorate([
        Output()
    ], FontStyleComponent.prototype, "textAlignChange", void 0);
    __decorate([
        Input()
    ], FontStyleComponent.prototype, "textAlign", null);
    __decorate([
        Input()
    ], FontStyleComponent.prototype, "isUnderline", void 0);
    __decorate([
        Output()
    ], FontStyleComponent.prototype, "isUnderlineChange", void 0);
    __decorate([
        Output()
    ], FontStyleComponent.prototype, "fontColorChange", void 0);
    __decorate([
        Input()
    ], FontStyleComponent.prototype, "fontColor", null);
    __decorate([
        Output()
    ], FontStyleComponent.prototype, "fontStyleChange", void 0);
    __decorate([
        Input()
    ], FontStyleComponent.prototype, "fontStyle", null);
    __decorate([
        ViewChild('FontSizeDropdown', { static: false })
    ], FontStyleComponent.prototype, "fontSizeDropdown", void 0);
    FontStyleComponent = __decorate([
        Component({
            selector: 'font-style',
            template: "﻿<div class=\"design-font-style\"> <div class=\"textToolBar\" provide-parent-forms> <div class=\"font-family\"> <p-dropdown #FontFamilyDropdown class=\"fontFamily\" name=\"fontFamily\" [options]=\"fontFamilies\" [(ngModel)]=\"fontFamily\" [style]=\"{'width':'100px' , 'min-width': '100px'}\" (onChange)=\"onFontFamilyChanged()\"> <ng-template let-item pTemplate=\"selectedItem\"> <span>{{lc(item.label)}}</span> </ng-template> <ng-template let-font pTemplate=\"item\"> <span>{{lc(font.label)}}</span> </ng-template> </p-dropdown> </div> <p-dropdown #FontSizeDropdown class=\"fontSize\" name=\"fontSize\" [options]=\"fontSizes\" [(ngModel)]=\"fontSize\" [style]=\"{'width':'80px' , 'min-width': '80px'}\" editable=\"true\" (onChange)=\"onFontSizeChanged($event)\" (keydown)=\"onFontSizeKeyDown($event)\" [custom-func-validate]=\"validateFontSize\"></p-dropdown> <span> <a class=\"bold\" [ngClass]=\"{'clicked': isBold}\" (click)=\"setBold()\"></a> </span> <span> <a class=\"italic\" [ngClass]=\"{'clicked': isItalic}\" (click)=\"setItalic()\"></a> </span> <span> <a class=\"underline\" [ngClass]=\"{'clicked': isUnderline}\" (click)=\"setUnderline()\"></a> </span> <span *ngIf=\"textAlignEnabled\"> <a class=\"alignLeft\" [ngClass]=\"{'clicked': alignLeft}\" (click)=\"setAlignLeft()\"></a> </span> <span *ngIf=\"textAlignEnabled\"> <a class=\"alignCenter\" [ngClass]=\"{'clicked':alignCenter}\" (click)=\"setAlignCenter()\"></a> </span> <span *ngIf=\"textAlignEnabled\"> <a class=\"alignRight\" [ngClass]=\"{'clicked': alignRight}\" (click)=\"setAlignRight()\"></a> </span> <span> <a class=\"fontColor\"> <font-color-picker [color]=\"fontColor\" (sentColor)=\"setFontColor($event)\"></font-color-picker> </a> </span> </div> </div>",
            styles: [".design-font-style{ .form-control { background-color: white; } .fontFamily { label{ padding: 0.4em; } } .textToolBar { background-color:transparent; display: inline-flex; height: 24px; select{ float: left; width: 80px; height: 32px; padding: 0; } a { text-decoration: none; display: inline-block; height: 20px; cursor: pointer; width: 20px; vertical-align: -webkit-baseline-middle; background-image: url(\"/assets/common/images/configure/textToolBar.png\"); } ::ng-deep .ui-inputtext{ padding-top: 5px; padding-bottom: 6px; } .font-family{ margin-right: 10px; } } .textToolBar>span { float: left; padding: 0 2px; line-height: 24px; } .textToolBar>span:last-child{ position: relative; } .bold { background-position: -40px 0px; } .bold.clicked { background-position: 0px 0px; } .italic { background-position: 80px 20px; } .italic.clicked { background-position: 120px 20px; } .underline { background-position: 140px 0px; } .underline.clicked { background-position: 180px 0px; } .alignLeft { background-position: 80px 0px; } .alignLeft.clicked { background-position: 120px 0px; } .alignCenter { background-position: 20px 0px; } .alignCenter.clicked { background-position: 60px 0px; } .alignRight { background-position: 200px 20px; } .alignRight.clicked { background-position: 240px 20px; } .fontColor { background-position: 140px 20px; } .fontColor.clicked { background-position: 180px 20px; } .colorPicker{ position: absolute; right: 5px; bottom: -2px; width: 13px; height: 2px; border: none; } .noResize { resize: none; } }"]
        })
    ], FontStyleComponent);
    return FontStyleComponent;
}(ConfigureComponentBase));
export { FontStyleComponent };
